export const AllowedExtensions: readonly string[] = [
  'doc',
  'xlsx',
  'xls',
  'odt',
  'pdf',
  'txt',
  'docx',
  'zip',
  'csv',
  'xlsm',
];

// Maps each allowed extension → its valid MIME types
// Some extensions have multiple valid MIMEs (e.g. xlsx has two)
export const AllowedMimeTypes: Record<string, string[]> = {
  doc: ['application/msword'],
  xlsx: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ],
  xls: ['application/vnd.ms-excel'],
  odt: ['application/vnd.oasis.opendocument.text'],
  pdf: ['application/pdf'],
  txt: ['text/plain'],
  docx: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  zip: ['application/zip', 'application/x-zip-compressed'],
  csv: ['text/csv', 'text/plain'],
  xlsm: ['application/vnd.ms-excel.sheet.macroEnabled.12'],
};

export const AllowedMimeTypesList: readonly string[] = [
  ...new Set(Object.values(AllowedMimeTypes).flat()),
];

export const FileSizeLimit = 1025000000; // 1 GB

export enum FileValidationErrors {
  InvalidFileExtension = 'Invalid file type. Supported extensions are: ##AllowedTypes##.',
  InvalidFileSize = 'File size exceeds the maximum allowed limit of 1 GB.',
  InvalidMIMEType = 'Invalid file format detected. MIME type does not match the file extension.',
  InvalidMagicBytes = 'File validation failed. File content does not match the expected file type.',
  InvalidFileName = 'File name contains invalid characters. Only letters, numbers, spaces, hyphens (-), underscores (_), and dots (.) are allowed. Please rename and try again.',
}
